module.exports = __webpack_public_path__ + "img/icon-yt.cc83aec1.png";